module.exports = __webpack_public_path__ + "static/yenepoya-11910fece45e87562a3a03ed4267b2be.png";